import { BehaviorSubject } from 'rxjs';
import { CoordinatorService } from './coordinator.service';
import { XItem } from './x-item';
import { OnlineCommunicator } from './online-communicator';
import { ParserFile } from './parser-file';

export class Online$ {
    cc!: OnlineCommunicator;

    constructor(private coords: CoordinatorService) {}

    onStart() {
        this.cc = this.coords.databin$.getCommunicator('online') as OnlineCommunicator;

        this.coords.worker$.parser.response$.subscribe((x) => {
            if (x.action !== 'connection') return;
            const c = this.coords.databin$.getConnection(x.payload.connectionId);
            if (!c) return;
            // c.parserResponse(x.payload.resp)
            // this.coords.databin$.cacheXitemLs(this.cc, x.payload.resp.cacheLs)
        });

        this.coords.worker$.online.response$.subscribe({
            next: (x) => this._workerResponse(x),
            error: (e) => console.log(e),
        });
    }

    get connection() {
        return this.coords.databin$.editedConnection$.getValue();
    }

    private _fetchTextResponse(payload: { text: string; connectionId: string }) {
        const pf = this.coords.databin$.createParserFile({
            connection: this.coords.databin$.getConnection(payload.connectionId)!,
            rawText: payload.text,
        });
        pf.parse();
    }

    private _parseCrossRefData(payload: { messages: any[]; connectionId: string }) {
        console.log(`[CrossRef]: Got a request to parse ${payload.messages.length} crossref items`);

        const pf = this.coords.databin$.createParserFile({
            connection:
                this.coords.databin$.getConnection(payload.connectionId) || payload.connectionId,
            payload: {
                type: 'crossref',
                data: payload.messages,
            },
        });
        pf.parse();
    }

    private _parseArxivData(payload: { data: string; connectionId: string }) {
        const pf = this.coords.databin$.createParserFile({
            connection: this.coords.databin$.getConnection(payload.connectionId)!,
            payload: {
                type: 'arxiv',
                data: payload.data,
            },
        });
        pf.parse();
    }

    private _command(params: any) {
        const c = this.coords.databin$.getConnection(params.connectionId);
        if (!c) return;
        c.command(params);
    }

    private _workerResponse(params: any) {
        // console.log("Online$ worker response", params)
        const p = params.payload;
        switch (params.action) {
            case 'success':
                return;
            case 'command':
                return this._command(p);
            case 'fetch-text':
                return this._fetchTextResponse(p);
            case 'parse-crossref-data':
                return this._parseCrossRefData(p);
            case 'parse-arxiv-data':
                return this._parseArxivData(p);
            // case "store":
            //     return this._store(p)
            // case "report":
            //     return this._report(p)
            default:
                this.coords.utils$.consoleInfo({
                    tag: 'ONLINE Response',
                    payload: params,
                    color: 'orange',
                    background: 'blue',
                });
        }
    }

    post(action: string, target: string, payload: any) {
        this.coords.worker$.online.directPost({
            action: action,
            target: target,
            payload: payload,
        });
        // 10.1186/s12906-024-04370-z
        // console.log(123342, {
        //     action: action,
        //     target: target,
        //     payload: payload
        // })
    }
}
